import { render, staticRenderFns } from "./wholesaleList.vue?vue&type=template&id=2932b601&scoped=true&"
import script from "./wholesaleList.vue?vue&type=script&lang=js&"
export * from "./wholesaleList.vue?vue&type=script&lang=js&"
import style0 from "./wholesaleList.vue?vue&type=style&index=0&id=2932b601&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2932b601",
  null
  
)

export default component.exports